<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="bOptions"
      >
        <template v-slot:item.quantity_added="{ item }">
          {{ getQuantity("ADD", item) }}
        </template>
        <template v-slot:item.quantity_used="{ item }">
          {{ getQuantity("USE", item) }}
        </template>
        <template v-slot:item.quantity_remaining="{ item }">
          {{ getQuantity("", item) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { inventory } from "@/api";

export default {
  name: "InventoryHistory",
  props: ["id"],
  data: () => ({
    loading: false,
    options: {},
    totalItems: 0,
    items: [],
    headers: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Date", value: "created_at" },
      { text: "Car", value: "car_number" },
      { text: "Driver", value: "driver_name" },
      // { text: 'Driver', value: 'item_count_before' },
      // { text: 'Driver', value: 'item_count_after' },
      { text: "New", value: "quantity_added" },
      { text: "Used", value: "quantity_used" },
      { text: "Remaining", value: "quantity_remaining" },
      { text: "Vin", value: "vin_number" },
      { text: "Active", value: "action" },
      { text: "Note", value: "note" },
    ],
  }),

  methods: {
    initialize() {
      this.getList();
    },

    async getList() {
      const { page = 1, itemsPerPage = 10 } = this.bOptions;
      this.loading = true;
      const response = await inventory.history(this.id, itemsPerPage, page);
      this.totalItems = response.data.count;
      this.items = response.data.data;
      this.loading = false;
    },
    getQuantity(action, item) {
      let quantity = item.item_count_after;
      if (action === "ADD") {
        // quantity = "";
        if (item.action === "ADD") {
          quantity = item.item_count_after - item.item_count_before;
        }
      } else if (action === "USE") {
        quantity = "";
        if (item.action === "USE") {
          quantity = item.item_count_before - item.item_count_after;
        }
      }
      return quantity;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>